// Final Merged ArchivedSessions.jsx
import React, { useRef, useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import "../../../styles/ArchivedSessions.css";
import { IoIosArrowBack } from "react-icons/io";
import logo from "../../../assets/icons/NewLogo.png";
import nodata from "../../../assets/images/nodata.png"
import DeleteIcon from "../../../assets/icons/delete.svg";
import { PatientServices } from "../services/PatientServices";
import { formatToLocalDateFancy, formatToLocalDateTimeFancy , formatToLocalTimeFancy} from "../../../shared/utils/dateFormatter";
import OverlayHeader from "../../../shared/components/OverlayHeader";
import { MdOpacity } from "react-icons/md";

export default function ArchivePanel({ onClose }) {
  const [selectMode, setSelectMode] = useState(false);
  const [selectedItems, setSelectedItems] = useState([]);
  const [showConfirmPopup, setShowConfirmPopup] = useState(false);
  const [actionType, setActionType] = useState("");
  const [showSuccessPopup, setShowSuccessPopup] = useState(false);
  const [successMessage, setSuccessMessage] = useState("");
  const [activeMenuIndex, setActiveMenuIndex] = useState(null);
  const [archiveConversation, setArchiveConversation] = useState([]);
  const [conversation_id, setConversation_id] = useState("");
  const [actionSource, SetActionSource] = useState(false);
  const [overlayRefresh, setOverlayRefresh] = useState(null);
  const [modalMessage, setModalMessage] = useState(false);
  const [showImage, setShowImage] = useState(false);
   

  let menuRef = useRef(null);
  let conv_date = null;
  const navigate = useNavigate();

  const ArchiveConversations = async () => {
      try {
        setModalMessage("loading archived conversation");
        const response = await PatientServices.fetchArchiveConversations();
        const data = response?.conversations || [];
        setArchiveConversation(data);
        setModalMessage(false);
        setShowImage(true);
      } catch (error) {
        console.error("Error loading Archieve conversations:", error);
      }
    };

  useEffect(() => {
    

    ArchiveConversations();
  }, [overlayRefresh]);

  const toggleSelectMode = () => {
    setSelectMode(!selectMode);
    setSelectedItems([]);
  };

  const handleCheckbox = (index) => {
    console.log("conversation ids", index);
    if (selectedItems.includes(index)) {
      setSelectedItems(selectedItems.filter((i) => i !== index));
    } else {
      setSelectedItems([...selectedItems, index]);
    }
  };

  const handleRestore = (conversation_id, index, source) => {
    if (source === "one") {
      SetActionSource(false);
    } else if (source === "many") {
      SetActionSource(true);
    }
    setActionType("restore");
    setShowConfirmPopup(true);
    setConversation_id(conversation_id);
    //ArchiveConversations();
  };

  const handleDelete = (conversation_id,index, source) => {
    if (source === "one") {
      SetActionSource(false);
    } else if (source === "many") {
      SetActionSource(true);
    }
    setActionType("delete");
    setShowConfirmPopup(true);
    setConversation_id(conversation_id);
    //ArchiveConversations();
    
  };

    const restoreArchive = async (conv_id) => {
    try {
      console.log('the conversation id we have here is', conv_id);
      const response = await PatientServices.restoreArchive(conv_id);
      console.log('conversation restore dsuccesfully', response);
      await ArchiveConversations();
    } catch (error) {
      console.error('error while archiveing the conversation', error);
    }
  };
  const deleteArchive = async (conv_id) => {
    try {
      console.log(
        "conversation id for deleting the archieve conversation",
        conv_id
      );
      const response = await PatientServices.deleteArchive(conv_id);
      console.log("conversation deleted successfully", response);
      await ArchiveConversations();
    } catch (error) {
      console.error("error while deleting the conversation", error);
    }
  };

  useEffect(() => {
    function handleClickOutside(event) {
      if (
        menuRef.current &&
        !menuRef.current.contains(event.target)
      ) {
        setActiveMenuIndex(null);  // close the menu
      }
    }

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const deleteMany = async (selectedItems) => {
    try {
      console.log("conversavation_ids passsing to the apis", selectedItems);
      const response = await PatientServices.deleteMany(selectedItems);
      console.log("conversation ids deleted succesfully", response);
      await ArchiveConversations();
    } catch (error) {
      console.error("error while deleting mutiple conversations", error);
    }
  };

const restoreMany = async (selectedItems) => {
    try {
      console.log(
        'conversations_ids passed to restore many conversations',
        selectedItems
      );
      const response = await PatientServices.restoreMany(selectedItems);
      console.log('successfully deleted the comversations', response);
      await ArchiveConversations();
    } catch (error) {
      console.error('error while restoring multiple conversations', error);
    }
  };

  useEffect(() => {
  if (archiveConversation.length > 0) {
    const timer = setTimeout(() => {
      setModalMessage(false);
    }, 2000); // wait 2 sec

    return () => clearTimeout(timer); // cleanup if component unmounts
  }
}, [archiveConversation]);

  return (
    <div className="archived-container">
       <OverlayHeader onBack={onClose} />
      {/*<div className="archived-header">
        <button className="archived-back-button" onClick={() => navigate(-1)}>
          <IoIosArrowBack size={18} />
          <span></span>
        </button>
        <img src={logo} alt="Logo" className="archived-logo" />
      </div>*/}

      <div className="archived-content">
        <div className="archived-title-bar">
        {archiveConversation.length > 0 ? (
          
          <h2>Archived Sessions ({archiveConversation.length})</h2>
        ) : (
          
                    <div
                      className="feedback-moda"
                      style={{
                        
                        display: showImage ?  "flex" : "none",  // use flex
                        justifyContent: "center",                 // center horizontally
                        alignItems: "center",                     // center vertically
                        position: "fixed",                        // fixed in viewport
                        top: 0,
                        left: 0,
                        width: "100%",
                        height: "100%",
                        flexDirection: "column",                  // stack img + text
                      }}
                    >
                      <img
                        src={nodata}
                        alt="Prashasync Logo"
                        className="modal-logo-google"
                        style={{ 
                          maxWidth: "150px", 
                          marginBottom: "20px" 
                        }}
                      />
                      <h3>No Archived Sessions available</h3>
                    </div>
              
          
        )}
          <span
            className="archived-select-link"

            onClick={() => {
              if (!selectMode) {
                setSelectMode(true);
              } else if (selectedItems.length !== archiveConversation.length) {
               setSelectedItems(archiveConversation.map((session) => session.conversation_id));
              } else {
                setSelectMode(false);
                setSelectedItems([]);
              
              }
              console.log('the selected items are', selectedItems)
            }}
          >
           {archiveConversation.length > 0 && (
              !selectMode
                ? "Select"
                : selectedItems.length !== archiveConversation.length
                ? "Select all"
                : "Cancel"
        )}
              
          </span>
        </div>

        <div className="archived-list">
  <ul className="conversation-list">
  {archiveConversation
    .slice()
    .sort((a, b) => new Date(b.createdat) - new Date(a.createdat))
    .map((session, index, arr) => {
      const convDate = formatToLocalDateFancy(session.createdat);

      // Show date header only if it's the first item OR date changed
      const prevDate = index > 0 ? formatToLocalDateFancy(arr[index - 1].createdat) : null;
      const showDateHeader = index === 0 || convDate !== prevDate;

      return (
        <React.Fragment key={session.conversation_id}>
          {showDateHeader && (
            <li className="date-header">
              <b>On {convDate}</b>
            </li>
          )}

          <li className="conversation-item">
            <div className="archived-session-row">
              <div className="archived-session-label">
                {selectMode && (
                  <input
                    type="checkbox"
                    checked={selectedItems.includes(session.conversation_id)}
                    onChange={() => handleCheckbox(session.conversation_id)}
                  />
                )}
                <span>
                  {"\u00A0\u00A0\u00A0" +
                    formatToLocalTimeFancy(session.createdat) +
                    " : " +
                    session.title}
                </span>
              </div>
            <div ref={menuRef} className="archived-menu-wrapper">
              <button
                className="archived-more-btn"
                onClick={() =>
                  setActiveMenuIndex(
                    activeMenuIndex === index ? null : index
                  )
                }
              >
                ⋮
              </button>

              {activeMenuIndex === index && (
                <div className="archived-popup-menu">
                  <div
                    className="archived-popup-option"
                    onClick={() =>{
                      handleRestore(session.conversation_id, null, "one");
                      setActiveMenuIndex(null);
                    }}
                  >
                    <span style={{ fontSize: "20px", marginRight: "8px" }}>⟲</span>
                    Restore
                  </div>
                  <hr />
                  <div
                    className="archived-popup-option delete"
                    onClick={() =>{
                      handleDelete(session.conversation_id, index, "one");
                      setActiveMenuIndex(null);
                    }}
                  >
                    <img
                      src={DeleteIcon}
                      alt="Delete"
                      className="setting-icon"
                      style={{ marginRight: "8px" }}
                    />{" "}
                    Delete
                  </div>
                </div>
              )}
              </div>
            </div>
          </li>
        </React.Fragment>
      );
    })}
</ul>

</div>


        {selectMode && (
          <div className="archived-footer">
            <button className="restore-btn"
              onClick={() => handleRestore(null, null, "many")} >
              ⟲ Restore
            </button>
            <button
              className="delete-btn"
              onClick={() => handleDelete(null, null, "many")}

            >
              <img
                src={DeleteIcon}
                alt="Delete"
                className="setting-icon"
                style={{
                  width: "18px",
                  height: "18px",
                  marginRight: "8px",
                  filter: "brightness(0) invert(1)",
                  verticalAlign: "middle",
                }}
              />{" "}
              Delete
            </button>
          </div>
        )}
      </div>

      {showConfirmPopup && (
        <div className="modal-overlay">
          <div className="modal-box">
            <h3>
              Permanently {actionType === "delete" ? "Delete" : "Restore"}?
            </h3>
            <p>
              Do you want to {actionType === "delete" ? "delete" : "restore"}{" "}
              permanently?
            </p>

            <div className="confirm-actions">
              <button
                className="cancel-btn"
                onClick={() => setShowConfirmPopup(false)}
              >
                No
              </button>
              <button
                className="confirm-btn"
                onClick={() => {
                  setShowConfirmPopup(false);  
                  console.log('the action source is', actionType, actionSource);              
                  if (actionSource && actionType === "delete") {
                    deleteMany(selectedItems);
                  } else if (actionSource && actionType === "restore") {
                    restoreMany(selectedItems);
                  } else if (!actionSource && actionType === "delete") {
                    deleteArchive(conversation_id);
                  } else if (!actionSource && actionType === "restore") {
                     restoreArchive(conversation_id);
                     
                  }
                  //window.location.reload();
                  setSuccessMessage(
                    actionType === "delete"
                      ? "Successfully Deleted!"
                      : "Successfully Restored!"
                  );
                  //setOverlayRefresh(actionType);
                  //ArchiveConversations();
                  setShowSuccessPopup(true);
                  setTimeout(() => setShowSuccessPopup(false), 2000);
                }}
              >
                {actionType === "delete" ? "Delete" : "Restore"}
              </button>
            </div>
          </div>
        </div>
      )}


{modalMessage && (
            
            <div className="feedback-modal-overlay">
                    <div className="feedback-modal">
                  <img
                    src={logo}
                    alt="Prashasync Logo"
                    className="modal-logo-google"
                  />
                  <h3>Please wait… </h3>
                  <p>{modalMessage} </p>
                </div>
              </div>
            
              
            )}


      {showSuccessPopup && (
        <div className="success-toast">
          <span>{successMessage}</span>
        </div>
      )}
    </div>
  );
}


